export const extraQueso =[
    { key: 'extra Queso',
      value: {
        personal: 2500,
        pequeña: 4000,
        mediana: 6000,
        grande: 8500,
      },
      img:require('../img/imgBordePizzas/eq.jpeg'),
      text: 'Extra Queso' ,
      description:'Deliciosa capa de queso mozarrella que recubre los ingredientes y le da un toque magico a tu pizza'
    },
    ]
